export default function CatalogueSkeleton() {
	return <div className="catalogue-skeleton" aria-hidden="true"><div /><span /><span /><span /></div>;
}
